"use client";
import PointsContainer from "@/components/PointsContainer/PointsContainer";
// import './doctorinfo.scss';
import HospitalCarousel from "@/components/HospitalsCarousel/HosptalsCarousel";
import FAQ from "@/components/FAQ/FAQ";
import PackageTreatment from "@/components/PackageTreatment/PackageTreatment";
import Treatments from "@/components/Treatments/Treatments";
import Image from "next/image";
import AnimateHeight from "react-animate-height";
import { useState } from "react";

import TreatmentPackagesCarousel from "../../app/components/TreatmentPackagesCarousel/TreatmentPackagesCarousel";
import { Helmet } from "react-helmet";

export default function Page({ topDoctorsDetails, treatmentPackagesData }) {
  const [height, setHeight] = useState(200);
  const doctorsDetails = topDoctorsDetails?.data && topDoctorsDetails?.data[0];
  const seoData =
    doctorsDetails?.doctors_detail && doctorsDetails?.doctors_detail?.seo;

  function symptomHeading() {
    return (
      <>
        <p className="boldHeading">Specialities</p>
      </>
    );
  }

  function specialInterest() {
    return (
      <>
        <p className="boldHeading">
          <span className="normalHeading">Special</span> Interests
        </p>
      </>
    );
  }

  function awardsHeading() {
    return (
      <>
        <p className="boldHeading">Awards</p>
      </>
    );
  }
  const sanitizedHTML =
    doctorsDetails && doctorsDetails?.doctors_detail?.descrption;

  return (
    <div className="flex flex-col w-full">
      <style jsx>{`
        .doctor-content {
          word-wrap: break-word;
          overflow-wrap: break-word;
          hyphens: auto;
        }

        .doctor-content p {
          margin-bottom: 12px;
          line-height: 1.6;
        }

        .doctor-content strong,
        .doctor-content b {
          font-weight: 600;
        }

        .doctor-content ul,
        .doctor-content ol {
          padding-left: 20px;
          margin-bottom: 12px;
        }

        .doctor-content li {
          margin-bottom: 4px;
          line-height: 1.5;
        }

        @media (max-width: 480px) {
          .doctor-content {
            font-size: 13px !important;
            line-height: 1.5 !important;
          }

          .doctor-content p {
            margin-bottom: 8px;
            text-align: left !important;
          }

          .doctor-content ul,
          .doctor-content ol {
            padding-left: 16px;
            margin-bottom: 8px;
          }

          .doctor-content li {
            margin-bottom: 3px;
            font-size: 13px;
          }

          .doctor-content h1,
          .doctor-content h2,
          .doctor-content h3,
          .doctor-content h4,
          .doctor-content h5,
          .doctor-content h6 {
            font-size: 16px !important;
            margin-bottom: 6px;
            margin-top: 12px;
            line-height: 1.3;
          }
        }

        @media (min-width: 481px) and (max-width: 768px) {
          .doctor-content {
            font-size: 14px !important;
            line-height: 1.55 !important;
          }

          .doctor-content p {
            margin-bottom: 10px;
            text-align: left !important;
          }
        }

        @media (min-width: 769px) {
          .doctor-content p {
            text-align: justify;
          }
        }
      `}</style>
      {/* <Helmet>
                <title>{seoData?.metaTitle}</title>
                <meta name="description" content={seoData?.metaDescription} />
                <meta name="keywords" content={seoData?.keywords} />
                <meta
                    property="og:title"
                    content={seoData?.metaSocial?.[0]?.title}
                />
                <meta
                    property="og:description"
                    content={seoData?.metaSocial?.[0]?.description}
                />
                <meta
                    property="og:image"
                    content={
                        seoData?.metaSocial?.[0]?.image?.url
                    }
                />
                <meta
                    property="og:url"
                    content={seoData?.metaSocial?.[0]?.socialpageurl}
                />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@site" />
                <meta name="twitter:creator" content="@handle" />
            </Helmet> */}
      {/* <BreadCrumbs /> */}
      <div className="doctorInfoWrapper w-full">
        <div className="doctorInfoContainer">
          <div className="aboutDoctorWrapper">
            <p className="normalHeading">
              About <span className="boldHeading">{doctorsDetails?.name}</span>
            </p>
            <div className="doctorDetailsContainer">
              {doctorsDetails?.profile?.url && (
                <Image
                  loading="lazy"
                  src={doctorsDetails.profile.url}
                  alt={`Dr. ${doctorsDetails.name}`}
                  width={220}
                  height={220}
                  className="rounded-full h-[120px] w-[120px] sm:h-[160px] sm:w-[160px] md:h-[200px] md:w-[200px] lg:h-[220px] lg:w-[220px] object-cover mx-auto"
                />
              )}
              <div className="nameDetailsContainer flex-1 text-center sm:text-left">
                <p className="doctornName text-[1.375rem] sm:text-[1.5rem] font-bold mb-2">
                  {doctorsDetails?.name}
                </p>
                {doctorsDetails?.Designation && (
                  <p className="designation text-sm sm:text-base mb-1">
                    {doctorsDetails.Designation}
                  </p>
                )}
                {doctorsDetails?.Department && (
                  <p className="department text-sm sm:text-base mb-1">
                    {doctorsDetails.Department}
                  </p>
                )}
                {doctorsDetails?.institute && (
                  <p className="studiedAt text-[1rem] sm:text-[1.125rem] text-gray-600 mb-1">
                    {doctorsDetails.institute}
                  </p>
                )}
                {doctorsDetails?.Visiting_consultant_at && (
                  <p className="hospital text-xs sm:text-sm text-gray-600 mb-1">
                    {doctorsDetails.Visiting_consultant_at}
                  </p>
                )}
                {(doctorsDetails?.city || doctorsDetails?.country) && (
                  <p className="location text-[1rem] sm:text-[1.125rem] mb-2">
                    <span className="font-medium">Location: </span>
                    {[doctorsDetails.city, doctorsDetails.country]
                      .filter(Boolean)
                      .join(", ")}
                  </p>
                )}
                {doctorsDetails?.gender && (
                  <p className="gender text-[1rem] sm:text-[1.125rem] mb-1">
                    <span className="font-medium">Gender: </span>
                    {doctorsDetails.gender}
                  </p>
                )}
              </div>
              <div className="experienceDetailsWrapper flex-shrink-0">
                {doctorsDetails?.surgeries && (
                  <div className="experienceDetailsContainer">
                    <p className="detailsBoldHeading text-center">
                      {doctorsDetails.surgeries}+
                    </p>
                    <p className="detailsHeading text-center">Surgeries</p>
                  </div>
                )}
                {doctorsDetails?.experiance && (
                  <div className="experienceDetailsContainer">
                    <p className="detailsBoldHeading text-center flex justify-center items-center flex-wrap">
                      {doctorsDetails.experiance}
                      <span className="ml-1">+ years</span>
                    </p>
                    <p className="detailsHeading text-center">Experience</p>
                  </div>
                )}
                {doctorsDetails?.rating && (
                  <div className="experienceDetailsContainer">
                    <p className="detailsBoldHeading text-center">
                      {doctorsDetails.rating}
                    </p>
                    <p className="detailsHeading text-center">Rating</p>
                  </div>
                )}
              </div>
            </div>

            <AnimateHeight
              style={{ width: "100%" }}
              id="example-panel"
              duration={500}
              height={height}
            >
              <div className="doctorDetailInfo">
                {sanitizedHTML && (
                  <div
                    className="doctor-content prose prose-sm sm:prose-base max-w-none w-full"
                    style={{
                      fontSize: "clamp(13px, 2.5vw, 16px)",
                      lineHeight: "1.6",
                      textAlign: "left",
                      color: "#333333",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: sanitizedHTML,
                    }}
                  />
                )}
              </div>
            </AnimateHeight>

            {sanitizedHTML && (
              <div className="showButtonContainer flex justify-center">
                <button
                  className="showMoreCostInIndiaBtn"
                  aria-expanded={height !== 200}
                  aria-controls="example-panel"
                  onClick={() => setHeight(height === 200 ? "auto" : 200)}
                >
                  {height === 200 ? "Show More +" : "View Less"}
                </button>
              </div>
            )}
          </div>

          <TreatmentPackagesCarousel itemsPerPage={4} data={treatmentPackagesData} />

          {doctorsDetails && doctorsDetails?.doctors_detail?.specialities && (
            <PointsContainer
              heading={symptomHeading()}
              color={"#557AF9"}
              data={
                doctorsDetails &&
                doctorsDetails?.doctors_detail?.specialities?.map((i) => i.name)
              }
              background={"linear-gradient(180deg, #E3F8FF 0%, #FBFDFE 100%)"}
              size="large"
              panelId="doctor-specialities-panel"
              minItemsForCollapseToggle={1}
            />
          )}

          {doctorsDetails && doctorsDetails?.doctors_detail?.interests && (
            <PointsContainer
              heading={specialInterest()}
              color={"#0EBE7F"}
              data={
                doctorsDetails &&
                doctorsDetails?.doctors_detail?.interests?.map((i) => i.name)
              }
              background={"#fff"}
              size="small"
            />
          )}

          <HospitalCarousel itemsPerPage={3} />
          {doctorsDetails && doctorsDetails?.doctors_detail?.membership && (
            <PackageTreatment
              heading="Memberships"
              treatment={
                doctorsDetails &&
                doctorsDetails?.doctors_detail?.membership.map((i) => i.name)
              }
            />
          )}

          {doctorsDetails && doctorsDetails?.doctors_detail?.awards && (
            <PointsContainer
              heading={awardsHeading()}
              color={"#557AF9"}
              data={
                doctorsDetails &&
                doctorsDetails?.doctors_detail?.awards.map((i) => i.name)
              }
              background={"linear-gradient(180deg, #E3F8FF 0%, #FBFDFE 100%)"}
              size="large"
              panelId="doctor-awards-panel"
              minItemsForCollapseToggle={1}
              wrapperClassName="doctorAwardsPointsWrapper"
            />
          )}

          {doctorsDetails && (
            <FAQ
              data={doctorsDetails?.doctors_detail?.faqs}
              className="doctorPageFaq"
            />
          )}
        </div>
      </div>
      <Treatments numOfRows={1} data={{ data: doctorsDetails?.treatments }} />
    </div>
  );
}
